// export variables

module.exports = {
    API_URL: "http://localhost:4000",
    PAYHERE_URL: "https://sandbox.payhere.lk/pay/checkout",
    PAYHERE_MERCHANT_ID: "1225326",
    PAYHERE_RETURN_URL: "https://modeonline.marketing/pay-success",
    PAYHERE_CANCEL_URL: "https://modeonline.marketing/pay-error",
    PAYHERE_NOTIFY_URL: "https://modeonline.marketing/customer/pay-notify"
};